import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';
import { queryKeys } from '@/lib/queryKeys';

export type ModuleAccessMap = Record<string, boolean>;

export interface ModuleAccessResponse {
  // false → the seat/subscription is inactive (no active seat, CANCELLED, or PAST_DUE
  // that never activated). The UI shows "Erişim kısıtlı" rather than "not in your package".
  subscriptionActive: boolean;
  modules: ModuleAccessMap;
}

const fetchModuleAccess = async (): Promise<ModuleAccessResponse> => {
  const res = await api.get('/subscription/modules');
  const data = res.data.data;
  // Default to active so a malformed/empty payload never falsely locks the user out;
  // module gating still falls back to per-module false, which is the safe direction.
  return {
    subscriptionActive: data?.subscriptionActive ?? true,
    modules: data?.modules ?? {},
  };
};

export function useModuleAccess() {
  const { user } = useAuth();

  return useQuery({
    queryKey: queryKeys.subscription.modules,
    queryFn: fetchModuleAccess,
    enabled: !!user && !user.isSuperAdmin && !user.isCompany,
    // Cache for 5 minutes. staleTime: 0 / gcTime: 0 previously refetched on every
    // mount and dropped the cache on unmount, which — combined with the (now removed)
    // duplicate provider — could briefly show stale "no access" for a module.
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
